import { useEffect } from 'react';

const useDisableScroll = (disabled: boolean) => {

	useEffect(() => {

		const html = document.documentElement;
		const body = document.body;
		const enableScroll = () => {

			html.style.overflow = '';
			body.style.overflow = '';
			body.style.paddingRight = '';

		};

		if (disabled) {

			const scrollBarWidth = window.innerWidth - html.clientWidth;

			html.style.overflow = 'hidden';
			body.style.overflow = 'hidden';
			body.style.paddingRight = `${scrollBarWidth}px`;

		} else {

			enableScroll();

		}

		return () => {

			enableScroll();

		};

	}, [ disabled ]);

};

export default useDisableScroll;
